const Event = (target) => {
  const el = {
    signups: target.querySelectorAll(".event-sign-up"),
    calendar: target.querySelectorAll(".addeventatc"),
  };

  const method = {
    init: () => {

      document.addEventListener('readystatechange', event => {
        if (event.target.readyState === 'complete') {

          if(el.calendar) {
            el.calendar.forEach((calendar) => {
              if(calendar) {
                calendar.style.visibility = 'hidden';
              }
            });
          }

          el.signups.forEach((signup) => {
            method.handleModal(signup);
          });

        }
      });
    },

    handleModal: (modal) => {
      const trigger = modal.previousElementSibling;
      const arrow = modal.firstElementChild;

      const modalMethod = {
        hideModal: () => {
          modal.classList.remove("event-sign-up--visible");

          if(el.calendar) {
            el.calendar.forEach((calendar) => {
              if(calendar) {
                calendar.style.visibility = 'hidden';
              }
            });
          }

          if (!trigger.classList.contains("button--white"))
            trigger.classList.add("button--light");
          window.removeEventListener("keyup", modalMethod.hideModalOnEscPress);
          window.removeEventListener(
            "click",
            modalMethod.hideModalOnOutsideClick
          );
        },

        hideModalOnEscPress: (event) => {
          if (event.key && event.key.match("Escape")) modalMethod.hideModal();
        },

        hideModalOnOutsideClick: (event) => {
          let clickedElement = event.target;

          do {
            if (clickedElement === modal || clickedElement === trigger) return;
            clickedElement = clickedElement.parentNode;
          } while (clickedElement);

          modalMethod.hideModal();
        },

        placeModalArrow: () => {
          arrow.style.width = `${trigger.getBoundingClientRect().width}px`;
        },

        showModal: () => {
          modal.classList.add("event-sign-up--visible");
          if (!trigger.classList.contains("button--white"))
            trigger.classList.remove("button--light");

          window.addEventListener("keyup", modalMethod.hideModalOnEscPress);
          window.addEventListener("click", modalMethod.hideModalOnOutsideClick);

          modal
            .querySelectorAll(".callout")
            .forEach((callout) => callout.remove());
        },
      };

      trigger.addEventListener("click", () => {
        if (!modal.classList.contains("event-sign-up--visible")) {
          modalMethod.showModal();
        } else {
          modalMethod.hideModal();
        }
      });
      modalMethod.placeModalArrow();
      window.addEventListener("resize", modalMethod.placeModalArrow);
    },
  };

  method.init();
};

export default Event;
